// extracted by mini-css-extract-plugin
export default {"root":"XeX7vS","button":"r_WbdF","flipped":"ZxQq8q"};